(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Matches
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('Invoicesgrouptrimestral', Invoicesgrouptrimestral);

  function Invoicesgrouptrimestral($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/invoicesgrouptrimestral/:id', {id: '@_id'}, {
    
      query: {
        method: 'GET',
        isArray: true
    }
  });
}}());


